import React from "react"
import BgIcon from "../../../images/bg-icon.svg"
import TeamWorkImg from "../../../images/team-work.png"

const WhenNecessary = () => {
  return (
    <>
      <section
        className="bg-cover bg-no-repeat pt-20 pb-32"
        style={{ backgroundImage: `url(${TeamWorkImg})`, minHeight: "800px" }}
      >
        <div className="container mx-auto px-6">
          <div className="w-full md:w-3/5 lg:w-2/5 xl:w-2/5 p-8 bg-secondary bg-opacity-70 text-white rounded-3xl shadow-xl">
            <h3 className="text-5xl pb-8 leading-tight">
              <span className="font-bold">When it is </span>necessary?
            </h3>
            <p className="pr-12 pb-12 text-3xl">
              Having a reliable team allows you to focus on the productivity of
              your projects, while saving costs and getting better quality
              results.
            </p>
          </div>
        </div>
      </section>
      <section className="bg-neutral">
        <div className="container mx-auto px-6 py-20">
          <h3 className="text-5xl font-bold pb-8 leading-snug">
            <span className="text-secondary font-bold block leading-tight">
              Quality
            </span>
            software
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 pb-6">
            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                QA
              </div>
              <h5 className="text-2xl">Management</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                QA
              </div>
              <h5 className="text-2xl">Engineers</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                AE
              </div>
              <h5 className="text-2xl">Automation Specialists</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                CM
              </div>
              <h5 className="text-2xl">Configuration Management</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                GT
              </div>
              <h5 className="text-2xl pl-2">Globalization Testers</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                PM
              </div>
              <h5 className="text-2xl">Project Management</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                TW
              </div>
              <h5 className="text-2xl">Technical Writers</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                UX
              </div>
              <h5 className="text-2xl">Writing</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default WhenNecessary
